import { Component } from "@basic-orange/component";
import bo from "@basic-orange/library";
var innertextTemplate = require("./templates/innertext.handlebars");
export class BreakpointTool extends Component {
    constructor(_elm, _componentId) {
        super(_elm, _componentId);
        if (!bo.hasValue(window.Foundation)) {
            window.Foundation = {};
        }
        if (!bo.hasValue(window.Foundation.MediaQuery)) {
            window.Foundation.MediaQuery = {
                current: 'fake breakpoint for debug purposes'
            };
        }
        if (this.data.islocal) {
            this.container = _elm;
            this.init();
            this.setEventListeners();
        }
    }
    init() {
        this.container.innerHtml = innertextTemplate({ breakpoint: 'none_set' });
        this.setState();
    }
    setState() {
        this.container.innerHTML = innertextTemplate({ breakpoint: window.Foundation.MediaQuery.current });
    }
    setEventListeners() {
        window.addEventListener("resize", this.onWindowResize.bind(this));
    }
    onWindowResize(event) {
        this.setState();
    }
}
//# sourceMappingURL=breakpointtool.js.map